<template>
  <div class="bg-dark-create" :class="[showmodal?'open':'']"></div>
  <div class="form-create-module question-quiz" :class="[showmodal?'open':'']">
    <div class="modal question" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Questões</h5>
            <button type="button" class="btn btn-primary" @click="createquestion()">Nova Questão</button>
          </div>
          <Loader :isActive="!hasReady"></Loader>
          <div class="modal-body" v-show="hasReady">
            <div class="form-group">
              <section class="config-form primary view-questions" v-for="questions,i in data" :key="i">
                <div class="content-text">
                  <div class="title quiz">
                    <h4>{{ i+1  }} ) {{removeTags(questions.description)}}</h4>
                    <div class="buttons">
                      <button
                        @click="openEditQuestion(questions.id, questions.description)"
                        type="button"
                        class="btn btn-light"
                      >
                        <i class="pi pi-pencil"></i>
                      </button>
                      <div class="button-order">
                        <button
                          type="button"
                          class="btn btn-light"
                          @click="moveUp(i,questions.id)"
                        >
                          <i class="pi pi-chevron-circle-up"></i>
                        </button>
                        <button
                          type="button"
                          class="btn btn-light"
                          @click="moveDown(i, questions.id)"
                        >
                          <i class="pi pi-chevron-circle-down"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    class="answer_quiz"
                    v-for="(asnwer, index ) in questions.answers" :key="index">
                    <input
                      :class="[asnwer.correct == 1 ? 'correct' : '']"
                      type="text"
                      class="form-control question"
                      :placeholder="removeTags(option[index])+' ) '+removeTags(asnwer.description)"
                      disabled
                    />
                  </div>
                </div>
              </section>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              @click="closetab()"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
            <button type="button" @click="closetab()" class="btn btn-primary">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
    <EditQuestion
      :id="idQuestion"
      :show="openmodaleditquestion"
      :title="titleQuestion"
      @open-tab="atualizarValorNoFilho"
      :idQuiz="idQuiz"
    ></EditQuestion>

    <CreateQuestion 
      :show="openmodalcreatequestion"
      @open-tab="atualizarValorNoFilho2"
      :idQuiz="idQuiz"
    ></CreateQuestion>


  </div>
</template>
<script>

import EditQuestion from './editquestion.vue'
import CreateQuestion from './createquestion.vue'
import api from '@/utils/answer';
import apiQuiz from '@/utils/quiz';
import { mapState } from 'vuex';
import Loader from '@/components/Loader/loader.vue';

export default {
  data(){
    return{
        showmodal:false,
        nameModule:'',
        demo:'',
        data:[],
        showItens:[],
        option:['A','B','C','D','E'],
        name:'',
        hasChange:false,
        openmodaleditquestion:false,
        openmodalcreatequestion: false,
        idQuestion:'',
        titleQuestion:'',
        hasReady:false
    }
  },
  props: {
    show: Boolean,
    idQuiz: Boolean
  },
  computed:{
    ...mapState(['token'])
  },
  methods: {
    removeTags(html) {
      return html.replace(/<\/?[^>]+(>|$)/g, "");
    },
    async getDataQuestion(){
      try {
        const response = await api.getAnswerByQuiz(this.idQuiz,this.token);
        console.debug('response:', response.content)
        this.data = response.content;
        this.hasReady=true;
      } catch (error) {
        console.error('Erro ao gerar listagem de questões', error)
      }
    },
    closetab() {
      this.showmodal = false;
      this.$emit('open-tab', this.showmodal)
    },
    opentab(){
        this.showmodal=true,
        this.$emit('open-tab', this.showmodal)
    },
    showHide(index){
        this.showItens[index]=!this.showItens[index];
    },
    moveUp(index, id) {
        if (index > 0) {
          try {
            const response = apiQuiz.moveUp(this.token, id);
            console.debug('Movido para cima', response);
          } catch (error) {
            console.error('Erro ao mover para cima', error);
          }
            const itemToMove = this.data[index];
            this.data.splice(index, 1);
            this.data.splice(index - 1, 0, itemToMove);
            }
        this.hasChange=true;
    },
    moveDown(index, id) {
        if (index < this.data.length - 1) {
          try {
            const response = apiQuiz.moveDown(this.token, id);
            console.debug('Movido para cima', response);
          } catch (error) {
            console.error('Erro ao mover para cima', error);
          }
        const itemToMove = this.data[index];
        this.data.splice(index, 1);
        this.data.splice(index + 1, 0, itemToMove);
     }
        this.hasChange=true;
    },
    updateinfo(){
    },
    atualizarValorNoFilho(novoValor){
        this.openmodaleditquestion = novoValor
    },
    openEditQuestion(id, title){
        this.idQuestion = id;
        this.titleQuestion = title
        this.openmodaleditquestion=!this.openmodaleditquestion;
    },
    createquestion(){
      this.openmodalcreatequestion = !this.openmodalcreatequestion;
    },
    atualizarValorNoFilho2(newvalue){
      this.openmodalcreatequestion = newvalue;
    },
  },
  components:{
    EditQuestion,
    CreateQuestion,
    Loader
  },
  watch: {
    show(newvalue) {
      this.showmodal = newvalue;
      this.getDataQuestion();
    },
    openmodaleditquestion(newvalue){
      this.hasReady=false;
      setTimeout(() => {
        this.getDataQuestion();
        console.debug(`OpenModalEdit Alterado`, this.openmodaleditquestion);
      }, 1000);
    },
    openmodalcreatequestion(newvalue){
      this.hasReady=false;
      console.debug(`OpenModalEdit`, this.openmodaleditquestion);
      setTimeout(() => {
        this.getDataQuestion();
        console.debug(`OpenModalEdit Alterado`, this.openmodaleditquestion);
      }, 1000);
    }
  },
};
</script>
<style scoped>
@import "./tabs.css";
.dashboard.dark input.form-control::placeholder, .dashboard.dark input.form-control {
  color: black !important;
  background-color: #444444;
}
.dashboard.dark  .form-label{
  color: white;
}
.modal.question button.btn.btn-light {
  padding: 10px !important;
  margin: 4px !important;
  height: 44px;
  color: black !important;
  background-color: transparent !important;
}
.modal.question {
  padding: 0;
}
.modal.question h4,.modal.question input.form-control {
  font-size: 15px;
}
.form-create-module.question-quiz.open {
  z-index: 9999;
}
.form-create-module.question-quiz.open {
  height: 94vh;
}
</style>
